import { render, staticRenderFns } from "./FDComponent.vue?vue&type=template&id=97ac1cb0&scoped=true&"
import script from "./FDComponent.vue?vue&type=script&lang=js&"
export * from "./FDComponent.vue?vue&type=script&lang=js&"
import style0 from "./FDComponent.vue?vue&type=style&index=0&id=97ac1cb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ac1cb0",
  null
  
)

export default component.exports